import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import useDocuments from '@/entity/hooks/use-documents';
const useOnboardingDocuments = (entity, onboarding) => {
  const $ = _c(6);
  const query = useDocuments(entity.id, onboarding.seqno);
  let t0;
  if ($[0] !== onboarding.id || $[1] !== query.data) {
    t0 = query.data?.filter(d => d.onboardingId === onboarding.id);
    $[0] = onboarding.id;
    $[1] = query.data;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== query || $[4] !== t0) {
    t1 = {
      ...query,
      documents: t0
    };
    $[3] = query;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default useOnboardingDocuments;